import Axios from "axios";
import { toastr } from 'react-redux-toastr';
import { SVCMessage } from './svcMessage';
import configJson from './config.json';
// import { history } from '../_helpers';

export const CommonConstants = {
  API_URL: configJson["CommonConstants"]["API_URL"],
  TC_URL: configJson["CommonConstants"]["TC_URL"],
  basePath: configJson["CommonConstants"]["Base_path"]
};

export const axios = Axios.create({
  baseURL: CommonConstants.API_URL,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
});

axios.interceptors.request.use(function (config) {

  // // spinning start to show
  // // UPDATE: Add this code to show global loading indicator
  // document.body.classList.add('loading-indicator');
  // Do something before request is sent
  var token = localStorage.getItem('token');
  var user = JSON.parse(localStorage.getItem('user'));
  if (token && user) {
    config.headers = { Authorization: `Bearer ${token}`, ud: user ? user.custom_person_name : null };
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // // spinning hide
  // // UPDATE: Add this code to hide global loading indicator
  // document.body.classList.remove('loading-indicator');
  // Do something with response data
  return response.data;
}, function (error) {
  // Do something with response error
  if (error.response && (error.response.status === 403 || error.response.status === 401)) {
    if (error.response.data == "invalid token.") {
      toastr.error('Error', SVCMessage['SVC_MSG_253']);
      if (window.location.pathname != CommonConstants.basePath +'/login') {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.href = CommonConstants.basePath +'/login'
        // window.location = 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise';
      }

    }
  }
  if(error.message==="Network Error"){
    if(window.location.pathname != CommonConstants.basePath +'/login'){
      // localStorage.removeItem("user");
      // localStorage.removeItem("token");
      // window.location.href = CommonConstants.basePath +'/network-error'
    }
  }else{
    return Promise.reject(error);
  }
});



// WEBPACK FOOTER //
// ./src/_helpers/api.js